import React from 'react';
import styled from 'styled-components';
import '../styles/globals.css'; // Import global styles

const MethodologyContainer = styled.div`
  max-width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f8f9fa;
`;

const PageWrapper = styled.div`
  width: 100%;
  max-width: var(--container-width);
  margin: 0 auto;
  padding: 0 24px;
  
  @media (max-width: 1024px) {
    padding: 0 24px;
  }
  
  @media (max-width: 768px) {
    padding: 0 16px;
  }
  
  @media (max-width: 480px) {
    padding: 0 16px;
  }
`;

const TitleSection = styled.div`
  width: 100%;
  padding: 2rem 0 0 0;
  
  @media (max-width: 768px) {
    padding: 1.5rem 0 0 0;
  }
`;

const Title = styled.h1`
  font-family: var(--font-soehne);
  font-weight: 600;
  color: #373737;
  font-size: 3.5rem;
  margin: 0 0 1rem 0;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-align: left;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
  }
`;

const ContentColumn = styled.div`
  width: 100%;
  padding: 0.5rem 0;
  color: #333;
  
  @media (max-width: 768px) {
    padding: 0.25rem 0;
    margin-bottom: 0;
  }
  
  a {
    color: #ae7cef;
    text-decoration: none;
    
    &:hover {
      color: #9a64dc;
    }
  }
`;

const MethodologyContent = styled.div`
  margin-bottom: 30px;
  
  h2 {
    margin-bottom: 20px;
  }
  
  p {
    margin-bottom: 15px;
    line-height: 1.6;
    font-size: 1rem;
    
    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }
  
  ol {
    margin-left: 2rem;
    margin-bottom: 1.5rem;
    list-style-type: decimal;
    
    @media (max-width: 768px) {
      margin-left: 1.5rem;
      font-size: 0.9rem;
    }
    
    li {
      margin-bottom: 8px;
      font-size: 1rem;
      line-height: 1.6;
      
      @media (max-width: 768px) {
        margin-bottom: 6px;
        font-size: 0.9rem;
      }
    }
  }
`;

function Methodology() {
  return (
    <MethodologyContainer>
      <PageWrapper>
        <TitleSection>
          <Title>METHODOLOGY</Title>
        </TitleSection>
        
        <ContentColumn>
          <MethodologyContent>
            <p>
              Our database of recommendations was built by scraping the full text of public AI action plans from prominent organizations, and using Anthropic's Claude model to extract recommendations. Here's the specific approach we took:
            </p>
            <ol>
              <li>We scraped the text of all submissions to OSTP's RFI, and then filtered them to those that included specific recommendations.</li>
              <li>We wrote code to parse and process each submission with Claude (claude-3-7-sonnet-latest) using the Anthropic API.</li>
              <li>Claude was asked to extract the recommendations from each action plan, and to provide analysis on the content (e.g. assignee, category, justification, etc). For example, the prompt for the "justification" field was "A justification for why this recommendation is important to do, according to the submission."</li>
              <li>Each recommendation was added to the database by the script, and uploaded to the website.</li>
            </ol>
            <p>
              If you notice any errors in the recommendations or information associated with each record, please reach out to <a href="mailto:ari@ifp.org">ari@ifp.org</a> and we would be happy to update the records.
            </p>
          </MethodologyContent>
        </ContentColumn>
      </PageWrapper>
    </MethodologyContainer>
  );
}

export default Methodology; 